module.exports = __webpack_public_path__ + "static/img/cont37_09.497a8c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_09.jpg
// module id = lK6R
// module chunks = 0